import { config } from "../config/constants";
import { concatWithSymbol } from './common';
import { getStorage, setStorage, StorageType } from "./storage";
export const utmKey = concatWithSymbol([config.uaId, 'utm']);
export function analyzeSearchParams() {
    const query = window.location.hash.split('?')[1];
    if (query) {
        const searchParams = new URLSearchParams(query);
        setUtm(searchParams);
        config.trackOriginOpenId && setOriginOpenId(searchParams);
    }
}
export function setUtm(searchParams) {
    const res = {};
    searchParams.forEach((v, k) => {
        if (v && /^utm_|^source$/.test(k)) {
            res[k] = decodeURIComponent(v);
        }
    });
    if (Object.keys(res).length) {
        setStorage(utmKey, res, false, StorageType.session);
    }
}
export function getUtm() {
    return getStorage(utmKey, StorageType.session);
}
// originalOpenId
export const opKey = concatWithSymbol([config.uaId, 'originOpenId(']);
export function setOriginOpenId(searchParams) {
    let originOpenId = '';
    searchParams.forEach((v, k) => {
        if (v && k === 'originOpenId') {
            originOpenId = decodeURIComponent(v);
        }
    });
    if (originOpenId) {
        setStorage(opKey, originOpenId, false, StorageType.session);
    }
}
export function getOriginOpenId() {
    return getStorage(opKey, StorageType.session);
}
setTimeout(analyzeSearchParams, 0);
